export default __webpack_public_path__ + "static/media/ruler.61912d02.png";